import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'replaceVars',
})
export class VariableReplacementPipe implements PipeTransform {
  /**
   * Replaces `{variable}` with the provided value and supports inline pluralization
   * using `{singular|plural}` tokens. If the numeric value equals 1, the singular
   * form is kept; otherwise the plural form is used.
   */
  transform(
    tpl: string,
    value: string | number,
    toFixedNumber = false,
    variableName = '{variable}'
  ): string {
    if (typeof value === 'number' && !isNaN(value)) {
      const displayedValue = toFixedNumber ? Number(value.toFixed(0)) : value;
      const result = tpl.replace(
        variableName,
        toFixedNumber ? displayedValue.toString() : (value || '').toString()
      );
      // Handle pluralization: {singular|plural}
      return result.replace(/\{([^|]+)\|([^}]+)\}/g, (_, singular, plural) =>
        displayedValue === 1 ? singular : plural
      );
    } else {
      return tpl.replace(variableName, (value || '').toString());
    }
  }
}
